import {SET_ADD_PASSENGER_WALLET} from "./action_add_passenger_wallet";

const INITIAL_STATE = {
    wallet: 'Loading...'
}

const walletPassengerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ADD_PASSENGER_WALLET:
            return {
                ...state,
                wallet: action.payload
            }
        default:
            return state;
    }
}

export default walletPassengerReducer;
